import {useQuery} from "react-query";
import {fetchBlob} from "../queries/queries-helper.ts";

const useFetchBlob = (url: string) => useQuery(
        ['blob', url],
        async () => {
            const blob = await fetchBlob(url);

            if (blob?.size) {
                return URL.createObjectURL(blob);
            }

            return null;
        },
        {
            enabled: !!url,
            staleTime: 60 * 60 * 1000, // 1 heure
            onError: (error) => {
                console.error("Erreur de récupération de la ressource : ", error);
            },
        }
    );

export default useFetchBlob;
